import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { InvitationEntity } from '../entities/MembershipEntity.js';

export interface CreateInvitationInput {
  orgId: string; roleId: string; projectId?: string | null; sessionId?: string | null;
  note?: string | null; expiresAt?: string | null; maxUses?: number | null; createdBy: string;
}

interface Deps { membershipRepository: IMembershipRepository; }
export function createCreateInvitationUseCase({ membershipRepository }: Deps) {
  return async function createInvitation(input: CreateInvitationInput): Promise<InvitationEntity> {
    return membershipRepository.createInvitation(input);
  };
}
